export const iconFontAwesomePhotosImagesImages = (
	<i className="fa-solid fa-images"></i>
);
